module.exports = __webpack_public_path__ + "static/media/nodejs.c4023b6d.svg";